import { localeManager, prefs } from '@reactive';
import { LocaleId } from '@strings';

import { ColorMode, ColorModePreference } from '@color';
import { ScriptingAPI } from './ScriptingAPI';

/* eslint-disable @typescript-eslint/class-literal-property-style */

// This is the scripting API object for the app as a whole. It provides access
// to app-wide settings and commands.
export class AppScriptingAPI extends ScriptingAPI {
  //
  // App and API Info
  //

  // The name of the app.
  get name(): string {
    return 'CADET';
  }

  // The version of the app.
  get appVersion(): string {
    return '0.1.0';
  }

  // The semantic version of the scripting API.
  get apiSemVer(): string {
    return '0.1.0';
  }

  //
  // Locale
  //

  get locales(): LocaleId[] {
    return Object.values(LocaleId);
  }

  get locale(): LocaleId {
    return localeManager.localeId;
  }

  set locale(id: LocaleId) {
    if (!this.locales.includes(id)) {
      throw new Error(`Invalid locale id: ${id}`);
    }
    localeManager.localeId = id;
  }

  nextLocale(): string {
    localeManager.nextLocale();
    return this.locale;
  }

  prevLocale(): string {
    localeManager.prevLocale();
    return this.locale;
  }

  //
  // Color Mode
  //

  get colorModes(): ColorModePreference[] {
    return Object.values(ColorModePreference);
  }

  get colorMode(): ColorModePreference {
    return prefs.colorModePreference;
  }

  set colorMode(value: ColorModePreference) {
    if (!this.colorModes.includes(value)) {
      throw new Error(`Invalid color mode: ${value}`);
    }
    prefs.colorModePreference = value;
  }

  get systemColorMode(): ColorMode {
    return prefs.systemColorMode;
  }

  //
  // Screencast Mode
  //

  get screencastMode(): boolean {
    return prefs.screencastMode;
  }

  set screencastMode(value: boolean) {
    prefs.screencastMode = value;
  }
}
